import { render, staticRenderFns } from "./VipWithdraw.vue?vue&type=template&id=90e93d42&scoped=true&"
import script from "./VipWithdraw.vue?vue&type=script&lang=js&"
export * from "./VipWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./VipWithdraw.vue?vue&type=style&index=0&id=90e93d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e93d42",
  null
  
)

export default component.exports